import {Button} from 'antd';
import React, {FC} from 'react';

import {IMetaActionInfo, setFormDraftMetadata} from 'entities/metadata';
import {useAppDispatch} from 'store/config/hooks';
import {requestSliceActions} from 'store/slices/request-slice/request-slice';

interface IButtonSaveDraftProps {
    actionType: IMetaActionInfo['actionType'];
    actionTitle: string;
    entityName: string;
}

export const ButtonSaveDraft: FC<IButtonSaveDraftProps> = ({
    actionType,
    actionTitle = 'Сохранить',
    entityName,
}: IButtonSaveDraftProps) => {
    const dispatch = useAppDispatch();
    const {setSubmitButtonActionType} = requestSliceActions;

    const handleClick = () => {
        dispatch(setFormDraftMetadata({
            entityName,
            isDraft: true,
        }));
        dispatch(setSubmitButtonActionType(actionType));
    };

    return (
        <Button
            type="primary"
            className="save-action-btn"
            onClick={handleClick}
            htmlType="submit"
        >{actionTitle}
        </Button>
    );
};
